import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteRFIActions'
import * as api from '../../api/job/jobSiteRfis'

function* jobSiteRFIsRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteRFIs, action.jobId)
    yield put({ type: constants.JOB_SITE_RFIS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_RFIS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteRFIs() {
  yield takeLatest(constants.JOB_SITE_RFIS_REFRESH.ACTION, jobSiteRFIsRefresh)
}

function* sagaCreateJobSiteRFI(action) {
  try {
    const payload = {
      rfi_data: {
        job_id: action.jobId,
        organization_id: action.content.organization_id,
        description: action.content.description,
        attention: action.content.attention,
        created_by_id: action.userId,
        updated_by_id: action.userId
      },
      rfi_items: action.rfiItems
    }
    yield call(api.createJobSiteRFI, payload)
    yield put({ type: constants.JOB_SITE_RFI_CREATE.SUCCESS, payload })
    yield call(jobSiteRFIsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_RFI_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteRFI() {
  yield takeLatest(constants.JOB_SITE_RFI_CREATE.ACTION, sagaCreateJobSiteRFI)
}

function* sagaUpdateJobSiteRFI(action) {
  try {
    const payload = {
      rfi_data: {
        job_id: action.jobId,
        organization_id: action.content.organization_id,
        description: action.content.description,
        attention: action.content.attention,
        status: action.content.status,
        updated_by_id: action.userId
      },
      rfi_items: action.rfiItems,
      rfi_id: action.rfiId
    }
    yield call(api.updateJobSiteRFI, payload)
    yield put({ type: constants.JOB_SITE_RFI_UPDATE.SUCCESS, payload })
    yield call(jobSiteRFIsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_RFI_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteRFI() {
  yield takeLatest(constants.JOB_SITE_RFI_UPDATE.ACTION, sagaUpdateJobSiteRFI)
}

function* sagaDeleteJobSiteRFI(action) {
  try {
    const payload = {
      rfi_id: action.rfiId
    }
    yield call(api.deleteJobSiteRFI, action.rfiId)
    yield put({ type: constants.JOB_SITE_RFI_DELETE.SUCCESS, payload })
    yield call(jobSiteRFIsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_RFI_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteRFI() {
  yield takeLatest(constants.JOB_SITE_RFI_DELETE.ACTION, sagaDeleteJobSiteRFI)
}

function* getRfiItems(action) {
  try {
    const payload = yield call(api.getRFIData, action.rfiId)
    yield put({ type: constants.GET_RFI_DATA.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_RFI_DATA.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetRfiItems() {
  yield takeLatest(constants.GET_RFI_DATA.ACTION, getRfiItems)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      rfiId: action.rfiId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_RFI_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { rfiId: action.rfiId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_RFI_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_RFI_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.rfiId)
    yield put({ type: constants.GET_RFI_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_RFI_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_RFI_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_RFI_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { rfiId: action.rfiId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_RFI_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(constants.UPDATE_RFI_ATTACHMENT_DESCRIPTION.ACTION, updateAttachmentDescription)
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      rfiId: action.rfiId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_RFI_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { rfiId: action.rfiId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_RFI_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_RFI_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteRFIs),

    fork(watchCreateJobSiteRFI),
    fork(watchUpdateJobSiteRFI),
    fork(watchDeleteJobSiteRFI),

    fork(watchGetRfiItems),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteRFISaga.js